import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AutomationModel, TriggeringActionType } from '../models/automation/automation.model';
import { FormService } from '../services/form.service';
import { FormType } from '../models/application/formType';
@Pipe({ name: 'autoAddAutomationName' })
export class AutoAddAutomaionNamePipe implements PipeTransform {
  constructor(private formService: FormService) {}
  transform(automation: AutomationModel): Observable<string> {
    switch (automation.automationTrigger.triggeringActionType) {
      case TriggeringActionType.FormSubmitted:
        return this.formService.activeTemplates.pipe(
          map((forms) => {
            if (!forms) {
              this.formService.getAllActiveTemplates(FormType.Application);
              return;
            }
            const formName = forms.find(
              (x) => x.id == automation.automationTrigger.entityId
            )?.title;
            if (formName) {
              return `${automation.triggeringActionTypeTitle}: ${formName}`;
            }
            return '';
          })
        );
      default:
        return of('');
    }
  }
}
